<app-modal #modal></app-modal>
<div *ngIf="isDefault">
  <div *ngFor="let tableSection of tableSections" [ngClass]="tableSection.tableClass === undefined ? 'body-table' : tableSection.tableClass">
    <div [innerHtml]="returnHtmlFromRichText(tableSection.table) | mdToHtml"></div>
  </div>
</div>
<div *ngIf="apiReferenceErrorResponsePage">
  <div *ngFor="let tableSection of tableSections" class="CommonTable">
    <h2>{{ tableSection.title }}</h2>
    <div class="body-table" [innerHtml]="returnHtmlFromRichText(tableSection.table) | mdToHtml"></div>
  </div>
</div>
<div *ngIf="apiReferenceXMLSamplePage">
  <div *ngFor="let tableSection of tableSections" class="CommonTable">
    <h4 [id]="tableSection.heading">{{ tableSection.title }}</h4>
    <p>{{ tableSection.body }}</p>
    <div class="body-table FileTable" [innerHtml]="returnHtmlFromRichText(tableSection.table) | mdToHtml"></div>
  </div>
</div>

<div *ngIf="languageSupportedPage || testingYourBuildSecureCardAuthenticationPage">
  <div *ngFor="let tableSection of tableSections" class="CommonTable">
    <div id="{{ tableSection.heading }}" [innerHTML]="tableSection.body | mdToHtml"></div>
    <div class="body-table AutoWidthTable" *ngIf="tableSection.table" [innerHtml]="returnHtmlFromRichText(tableSection.table) | mdToHtml"></div>
  </div>
</div>

<div *ngIf="testingYourBuildPage">
  <div *ngFor="let tableSection of tableSections" class="CommonTable">
    <div class="col-sm-12 title" id="{{ tableSection.heading }}" [innerHTML]="tableSection.body | mdToHtml"></div>
    <div class="body-table AutoWidthTable" *ngIf="tableSection.table" [innerHtml]="returnHtmlFromRichText(tableSection.table) | mdToHtml"></div>
  </div>
</div>
